import { render, staticRenderFns } from "./SmallBox.vue?vue&type=template&id=29da2cce&scoped=true"
import script from "./SmallBox.vue?vue&type=script&lang=ts"
export * from "./SmallBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da2cce",
  null
  
)

export default component.exports